import * as swcHelpers from '@swc/helpers';
import { useMutation, Types } from '@grandvisionhq/graphql';
import { SIGNUP_PROMOTION } from '../operations/mutations/signup-promotion.js';

const mapConsents = (selectedConsents)=>selectedConsents.map((consent)=>({
            consentName: consent.title,
            literalText: consent.title,
            uiType: Types.UIType.CHECKBOX,
            value: true
        })
    )
;
const mapOptIns = (optIns)=>optIns.map((optIn)=>({
            id: optIn.value,
            value: true,
            literalText: optIn.title,
            uiType: Types.UIType.CHECKBOX
        })
    )
;
var useSignupCampaign = ()=>{
    var ref, ref1, ref2, ref3;
    const [signupCampaignMutation, { data , loading  }] = useMutation(SIGNUP_PROMOTION);
    const callback = (_param)=>{
        var { consents , optIns , personalDetails  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
            "consents",
            "optIns",
            "personalDetails"
        ]);
        return signupCampaignMutation({
            variables: {
                signupPromotionInput: swcHelpers.objectSpread({
                    consents: mapConsents(consents),
                    optIns: mapOptIns(optIns),
                    personalDetails: {
                        firstName: personalDetails.firstName,
                        middleName: personalDetails.middleName,
                        lastName: personalDetails.lastName,
                        email: personalDetails.email
                    }
                }, rest)
            }
        });
    };
    return [
        callback,
        {
            campaignId: (data === null || data === void 0 ? void 0 : (ref = data.signupPromotion) === null || ref === void 0 ? void 0 : ref.success) ? data === null || data === void 0 ? void 0 : (ref1 = data.signupPromotion) === null || ref1 === void 0 ? void 0 : ref1.campaignId : '',
            isLoading: loading,
            error: (data === null || data === void 0 ? void 0 : (ref2 = data.signupPromotion) === null || ref2 === void 0 ? void 0 : ref2.errorMessage) || null,
            success: !!(data === null || data === void 0 ? void 0 : (ref3 = data.signupPromotion) === null || ref3 === void 0 ? void 0 : ref3.success)
        }, 
    ];
};

export { useSignupCampaign };
//# sourceMappingURL=use-signup-campaign.js.map
